import { useState, useEffect } from "react";
import styles from "./Reveal.module.css";

/**
 * cards fade + rise in on mount, staggered by `index * step` ms, and replay every
 * time `resetKey` changes (e.g. the active tab), matching the original's
 * per-tab-switch reveal exactly.
 */
export default function Reveal({
  children,
  index = 0,
  baseDelay = 40,
  step = 70,
  resetKey,
  className = "",
  id,
}) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    setShown(false);
    const t = setTimeout(() => setShown(true), baseDelay + index * step);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey, index, baseDelay, step]);

  return (
    <div
      id={id}
      className={`${styles.reveal} ${shown ? styles.revealIn : ""} ${className}`}
    >
      {children}
    </div>
  );
}
